import { allConfigs, EnvKey } from './environment.config';

const saved = localStorage.getItem('env') as EnvKey | null;
const currentEnv: EnvKey = ['dev', 'beta', 'prod'].includes(saved!)
  ? saved!
  : 'prod';

export const environment = {
  get current(): EnvKey {
    const saved = localStorage.getItem('env') as EnvKey | null;
    const env = ['dev', 'beta', 'prod'].includes(saved!) ? saved! : 'prod';
  
    console.log('🔍 Current environment:', env);
    return env;
  },

  get config() {
    console.log('🔍 Current environment:', allConfigs[this.current]);
    return allConfigs[this.current];
  },

  setEnvironment(env: EnvKey) {
    localStorage.setItem('env', env);
  },

  getEnvironment(): EnvKey {
    return this.current;
  },

  deviceName: 'teamsPlugin',
};
